import {Component, ContentChild, ContentChildren, Input, TemplateRef} from '@angular/core';

@Component({
    selector: 'scitis-app-global-page-header',
    templateUrl: './global-page-header.component.html',
    styleUrls: ['./global-page-header.component.scss'],
    standalone: false
})
export class GlobalPageHeaderComponent{

  @Input()
  pageTitle: string = '';

  @ContentChild(('entryCount'), {read: TemplateRef}) entryCountElement!: TemplateRef<any>;
  @ContentChildren(('filterElement'), {read: TemplateRef}) elements!: TemplateRef<any>[];
}
